/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FloatingServiceMenu.vue?vue&type=template&id=8b2df2d0&scoped=true"
import script from "./FloatingServiceMenu.vue?vue&type=script&lang=js"
export * from "./FloatingServiceMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingServiceMenu.vue?vue&type=style&index=0&id=8b2df2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2df2d0",
  null
  
)

export default component.exports